import type { AccountType } from '@dhl/mdp-api'
import { useDataAsyncCall } from '~/api/admin-api'

export const useAccountTypes = (organisationId: string): AccountType[] => {
  const [accountTypes] = useDataAsyncCall<AccountType[]>(`organisation/${organisationId}/account-types`)
  return accountTypes ?? []
}
